import { Component, OnInit } from '@angular/core';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { DeviceGroup_Interface } from 'src/app/Interface/DeviceGroup_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UserService } from 'src/app/Service/User/User.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-DeviceBehfaGozareshKarkard',
  templateUrl: './DeviceBehfaGozareshKarkard.component.html',
  styleUrls: ['./DeviceBehfaGozareshKarkard.component.scss']
})
export class DeviceBehfaGozareshKarkardComponent implements OnInit {


  Token:String=""
  selectedUser:String="0"
  page:number=0;
  Procssing:boolean=false;
  InProccessing:boolean=false;


  Filter_Code_BEHFA:string=""
  Filter_Code_User:string=""
  Filter_Code_Group:string=""

  Change_Filter(){
    this.page=0
  }

  DataList_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  constructor(
    private DeviceBehfa_Service:DeviceBehfaService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private User_Service:UserService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,52).subscribe(
      data=>{
        this.ReadDate_User()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  ReadData_DeviceBehfa(datepickerInputStartDaryaft,datepickerInputEndDaryaft,datepickerInputStartTahvil,datepickerInputEndTahvil){
    this.Procssing=true
    this.DeviceBehfa_Service.GetDeviceBehfaGozareshKarkard(
      datepickerInputStartDaryaft,
      datepickerInputEndDaryaft,
      datepickerInputStartTahvil,
      datepickerInputEndTahvil,
      this.selectedUser,
      this.Token).subscribe(

      data=>{
        this.DataList_DeviceBehfa=data
        this.Procssing=false

      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  DataList_User:Array<User_Interface>=[]
  ReadDate_User(){
    this.User_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_User=data
      }
    )
  }

  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "DaroDevice.xlsx");

  }


}
